<template>
  <form-group :messages="messages" :showSingleError="true" :validator="validationParam">
    <mt-field v-bind="$attrs" v-on="$listeners" :state="this.hiddenState ? '' : this.state" :readonly="isReadOnly" :disableClear="isReadOnly">
      <slot></slot>
    </mt-field>
  </form-group>
</template>

<script>

export default {
  name: 'CustomMtField',
  props: {
    validationParam: Object,
    messages: Object,
    hiddenState: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state: function () {
      if (this.validationParam) {
        if (this.validationParam.$anyDirty) {
          if (this.validationParam.$anyError) {
            return 'error'
          } else {
            return 'success'
          }
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
.mint-cell:after {
  background-color: transparent;
}

>>> .form-error {
  font-size: 12px;
  color: #ff5252;
  padding-left: 115px;  /* 與 mint-cell-title 寬度一致 */
  padding-bottom: 0.5rem;
  background-color: white;
}

>>> textarea {
  resize: none;
}

>>> .mint-cell {
  min-height: 2.2rem;
  width: 100%;
}

>>> .mint-cell-title {
  color: #404040;
  font-size: 0.8rem;
}

>>> .mint-cell-value > .mint-field-core {
  font-size: 0.8rem;
  color: gray;
}

>>> .mint-field-other {
  color: gray;
  font-size: 0.6rem;
}

>>> .mint-radiolist-title {
  margin: 0px;
  color: gray;
}

>>> .mint-radiolist-label {
  color: gray;
}

</style>
